import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse, IEecsGoAccount, SetGoAccountsPayload } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import { INecsAccount, SaveNecsAccountPayload } from '../types/necs-account.types';

export const necsAccountApi = createApi({
  reducerPath: 'necsAccountApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/necs/account`),
  endpoints: (builder) => ({
    getGoAccounts: builder.mutation<ApiResponse<IEecsGoAccount[]>, void>({
      query: () => ({
        url: `/goAccounts`,
        method: 'GET',
      }),
    }),

    setGoAccounts: builder.mutation<ApiResponse<any>, SetGoAccountsPayload>({
      query: (payload) => ({
        url: `/goAccounts`,
        method: 'POST',
        body: payload,
      }),
    }),

    saveAccount: builder.mutation<ApiResponse<INecsAccount>, SaveNecsAccountPayload>({
      query: (payload) => ({
        url: `/connect`,
        method: 'POST',
        body: payload,
      }),
    }),

    disconnectAccount: builder.mutation<ApiResponse<any>, any>({
      query: () => ({
        url: `/disconnect`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useSaveAccountMutation,
  useDisconnectAccountMutation,
  useGetGoAccountsMutation,
  useSetGoAccountsMutation,
} = necsAccountApi;
